import RxQuery from 'utils/api/rxQuery/rxQuery';
import endpoints from 'utils/api/endpoints';

const mockyApi = () => new RxQuery('mocky');

export const test = () => {
	return mockyApi()
		.setEndpoint(endpoints.mocky.test)
		.setErrorMsg('Error on connection to mocky');
};
